import { render, staticRenderFns } from "./SelectMallModal.vue?vue&type=template&id=236b13a0&scoped=true&"
import script from "./SelectMallModal.vue?vue&type=script&lang=ts&"
export * from "./SelectMallModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMallModal.vue?vue&type=style&index=0&id=236b13a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b13a0",
  null
  
)

export default component.exports